import { all } from 'redux-saga/effects';

import app from 'modules/app/sagas';
import appointmentSagas from 'modules/appointments/sagas';
import { appointmentTaskSagas } from 'modules/appointmentTask/sagas';
import newAuditModelsSagas from 'modules/auditModels/sagas';
import auditSagas from 'modules/audits/sagas';
import auditStatisticsSagas from 'modules/auditStatistics/sagas';
import authSagas from 'modules/auth/sagas';
import bodyScanSagas from 'modules/bodyScan/sagas';
import brandingTemplatesSagas from 'modules/brandingTemplates/sagas';
import brandSagas from 'modules/brands/sagas';
import cameraManagementSagas from 'modules/cameras/saga';
import campaignFilesSaga from 'modules/campaignFiles/sagas/core';
import campaignsSaga from 'modules/campaigns/sagas/core';
import ccmSaga from 'modules/ccm/sagas';
import chatSagas from 'modules/chat/sagas';
import clSagas from 'modules/checklists/sagas';
import config from 'modules/config/sagas';
import configuratorSagas from 'modules/configurator/sagas';
import contactListsSaga from 'modules/contactLists/sagas/core';
import contactMembersSaga from 'modules/contactMembers/sagas/core';
import dealerConfigurationSagas from 'modules/dealerConfiguration/sagas';
import dealerSagas from 'modules/dealers/dealerSagas';
import deviceSagas from 'modules/devices/sagas';
import followUpModelSagas from 'modules/followUp/sagas';
import gatesSagas from 'modules/gates/sagas/core';
import newGroupSagas from 'modules/groups/sagas';
import groupTemplatesSagas from 'modules/groupTemplates/sagas';
import guidelinesSagas from 'modules/guidelines/sagas';
import hardwareManagementSagas from 'modules/hardwares/sagas';
import i18nSagas from 'modules/i18n/sagas';
import interventionMediaSagas from 'modules/interventionMedia/sagas';
import interventionsSagas from 'modules/interventions/sagas/sagas';
import invoiceSagas from 'modules/invoices/sagas';
import kioskManagementSagas from 'modules/kiosks/sagas';
import leadsSagas from 'modules/leads/sagas';
import localStorage from 'modules/localStorage/sagas';
import lockersSagas from 'modules/lockers/sagas';
import mediaLibrarySagas from 'modules/mediaLibrary/saga';
import mediaSagas from 'modules/medias/sagas';
import messagingAccountsSaga from 'modules/messagingAccounts/sagas';
import metricsCoreSaga from 'modules/metrics/sagas/core.saga';
import notifications from 'modules/notifications/sagas';
import payerManagementSagas from 'modules/payers/sagas';
import paymentsSagas from 'modules/payments/saga';
import lockersCalendarSagas from 'modules/planning/sagas';
import predefinedMessagesSagas from 'modules/predefinedMessages/sagas';
import publicTokenSagas from 'modules/publicToken/sagas';
import questionModelsSagas from 'modules/questionModels/sagas';
import releasesSaga from 'modules/releases/sagas';
import reportIssuesSagas from 'modules/reportIssues/sagas/saga';
import screensaverCoreSaga from 'modules/screensaver/sagas/core';
import selfServicesSagas from 'modules/selfServices/sagas/core';
import serviceHeader from 'modules/serviceHeaders/sagas';
import stepsSaga from 'modules/steps/sagas/core';
import tagsSaga from 'modules/tags/sagas';
import templateSagas from 'modules/templates/sagas';
import tireBrandsSagas from 'modules/tireBrands/sagas';
import tscanSagas from 'modules/tireScan/sagas';
import { notificationsSagas as toastNotificationsSaga } from 'modules/toast-notifications/sagas';
import userGroupsSagas from 'modules/userGroups/sagas';
import newUsersSagas from 'modules/users/sagas';
import vehicleCheckModelsSagas from 'modules/vehicleCheckModels/sagas';
import whitelistSaga from 'modules/whitelist/saga';

import categoriesStatisticsSagas from './categoriesStatisticsSagas';
import customersSagas from './customersSagas';
import dealerConfigSagas from './dealerConfigSagas';
import derivativeSagas from './derivativeSagas';
import extensionSagas from './extensionSagas';
import languageSagas from './languageSagas';
import modelSagas from './modelSagas';
import offerSagas from './offerSagas';
import packSagas from './packSagas';
import tvaSagas from './tvaSagas';
import usersSagas from './userSagas';
import variantSagas from './variantSagas';
import dealerStatisticsSagas from '../modules/statistics/sagas';

export default function* rootSaga() {
  yield all([
    app(),
    appointmentSagas(),
    newAuditModelsSagas(),
    auditStatisticsSagas(),
    authSagas(),
    brandingTemplatesSagas(),
    ...brandSagas,
    campaignsSaga(),
    campaignFilesSaga(),
    contactListsSaga(),
    contactMembersSaga(),
    config(),
    configuratorSagas(),
    ...customersSagas,
    ...dealerSagas,
    dealerConfigSagas(),
    dealerStatisticsSagas(),
    metricsCoreSaga(),
    ...derivativeSagas,
    deviceSagas(),
    ...extensionSagas,
    invoiceSagas(),
    i18nSagas(),
    ...languageSagas,
    ...modelSagas,
    ...offerSagas,
    ...packSagas,
    templateSagas(),
    tscanSagas(),
    ...tvaSagas,
    usersSagas(),
    ...variantSagas,
    categoriesStatisticsSagas(),
    ...lockersSagas,
    groupTemplatesSagas(),
    toastNotificationsSaga(),
    lockersCalendarSagas(),
    appointmentTaskSagas(),
    clSagas(),
    localStorage(),
    auditSagas(),
    mediaSagas(),
    ccmSaga(),
    chatSagas(),
    userGroupsSagas(),
    newUsersSagas(),
    stepsSaga(),
    guidelinesSagas(),
    reportIssuesSagas(),
    newGroupSagas(),
    predefinedMessagesSagas(),
    notifications(),
    interventionsSagas(),
    dealerConfigurationSagas(),
    leadsSagas(),
    serviceHeader(),
    interventionMediaSagas(),
    questionModelsSagas(),
    selfServicesSagas(),
    vehicleCheckModelsSagas(),
    mediaLibrarySagas(),
    followUpModelSagas(),
    paymentsSagas(),
    kioskManagementSagas(),
    cameraManagementSagas(),
    hardwareManagementSagas(),
    tireBrandsSagas(),
    bodyScanSagas(),
    payerManagementSagas(),
    releasesSaga(),
    screensaverCoreSaga(),
    publicTokenSagas(),
    tagsSaga(),
    gatesSagas(),
    whitelistSaga(),
    messagingAccountsSaga(),
  ]);
}
